export function makeTitleTankerKey(zoneName?: string, tariff?: string): string {
  if (zoneName && tariff) {
    return `page.title.${zoneName}.${tariff}`
  }

  if (tariff) {
    return `page.title.${tariff}`
  }

  return 'order.main-page.title'
}
